import type { Blockchain } from "@anaconda/core/blockchain/types"
import type { OrderId } from "@rarible_int/anaconda_sdk/solana"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { SolanaCancelByOrderTransactionMoleculeReatom } from "./solana-cancel-by-order-molecule.reatom"

export function useSolanaCancelByOrder(
  orderId: OrderId,
  _blockchain?: Blockchain,
) {
  const { cancelByOrderActionFactory } = useMolecule(
    SolanaCancelByOrderTransactionMoleculeReatom,
  )
  const cancelByOrderAction = useMemo(
    () => cancelByOrderActionFactory(),
    [cancelByOrderActionFactory],
  )

  const mutate = useCallback(() => {
    cancelByOrderAction({ orderId })
  }, [cancelByOrderAction, orderId])

  return {
    mutate,
    cancelByOrderAction,
    isPending: !!cancelByOrderAction.pending(),
  }
}
